import { useEffect, useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { brl, StatusBadge } from "@/lib/format";
import { PageHeader, TableShell, StatusSelect, QuoteModal } from "@/components/admin/ui";

const STATUSES = ["Pendente", "Aprovado", "Recusado"];

export default function QuotesPage() {
  const [quotes, setQuotes] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/quotes").then((r) => setQuotes(r.data)).catch(() => setQuotes([]));
  useEffect(() => {
    load();
  }, []);

  const setStatus = async (quote, status) => {
    try {
      await api.patch(`/quotes/${quote.id}`, { status });
      toast.success(`Orçamento ${quote.number} → ${status}`);
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  if (!quotes) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 size={28} className="animate-spin text-[#FFB800]" />
      </div>
    );
  }

  return (
    <div data-testid="quotes-page">
      <PageHeader title="Orçamentos" sub={`${quotes.length} orçamentos no total`} testId="quotes-header">
        <button
          onClick={() => setOpen(true)}
          data-testid="quotes-new-button"
          className="flex items-center gap-2 rounded-full bg-[#FFB800] px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-black transition-transform hover:scale-105"
        >
          <Plus size={16} strokeWidth={3} /> Novo Orçamento
        </button>
      </PageHeader>
      <TableShell head={["Número", "Cliente", "Serviço", "Valor", "Status", "Data"]} testId="quotes-table">
        {quotes.map((q, i) => (
          <tr key={q.id} className="text-zinc-300 transition-colors hover:bg-white/[0.02]" data-testid={`quote-row-${i}`}>
            <td className="px-5 py-4 font-semibold text-white">#{q.number}</td>
            <td className="px-5 py-4">{q.client}</td>
            <td className="px-5 py-4">{q.service}</td>
            <td className="px-5 py-4 font-semibold text-white">{brl(q.value)}</td>
            <td className="px-5 py-4">
              <div className="flex items-center gap-2">
                <StatusBadge status={q.status} />
                <StatusSelect value={q.status} options={STATUSES} onChange={(s) => setStatus(q, s)} testId={`quote-status-select-${i}`} />
              </div>
            </td>
            <td className="px-5 py-4 text-zinc-500">{q.date}</td>
          </tr>
        ))}
      </TableShell>
      <QuoteModal open={open} onClose={() => setOpen(false)} onCreated={load} />
    </div>
  );
}
